import React from 'react';
import PropTypes from 'prop-types';
import styles from './Section.module.css';

const Section = ({ title, children, className = '', style, variant }) => {
const variantStyle = variant === 'subsection' 
  ? { marginTop: '-2rem', ...style }
  : style;

return (
  <div 
    className={`${styles.section} ${variant === 'subsection' ? styles.subsection : ''} ${className}`} 
    style={variantStyle}
  >
    {title && <h4 className={styles.sectionTitle}>{title}</h4>}
    {children}
  </div>
);
};

Section.propTypes = {
  title: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
  variant: PropTypes.oneOf(['subsection', 'default'])
};

Section.defaultProps = {
  className: '',
  variant: 'default'
};

export default Section;